<template>
  <div class="layer-category-list">
    <div v-for="(cat, index) in categories" :key="index">
      <dropdown
        :label="cat.label"
        :category="cat"
        :icon="cat.icon"
        :open.sync="cat.open"
      >
        <slot :name="cat.id" :item="cat">
          <layer-list :items="cat.items" />
        </slot>
      </dropdown>
    </div>
  </div>
</template>

<script>
import Dropdown from './layer-category-dropdown.vue'
import LayerList from './layer-list.vue'
export default {
  components: {
    Dropdown,
    LayerList
  },
  props: {
    categories: {
      type: Array,
      default: () =>
        [...Array(4).keys()].map(num => ({
          id: `category-${num}`,
          label: `Category ${num}`,
          items: [...Array(4).keys()].map(numItem => ({
            id: `item-${num}-${numItem}`,
            label: `Item ${num} ${numItem}`
          }))
        }))
    }
  }
}
</script>

<style lang="scss" scoped></style>
